import React, { useState } from 'react'
import FormContatti from '../../organisms/FormContatti/FormContatti'
import TeamCard from '../../molecules/TeamCard/TeamCard'
import { Breadcrumbs, MetaSeo, Trans } from '../../../components/index'

const ContattiTemplate = ({ contattaciMenu, motivazioni, reparti, nazioni, page }) => {
  const [repartoId, setRepartoId] = useState(null)

  const contattaciMenuItem = contattaciMenu?.contattaci
  const customerServiceMenuItem = contattaciMenu?.customer_service

  return (
    <>
      <div className="page w-container contatti_template">
        <MetaSeo seo={page.seo} />
        <Breadcrumbs breadcrumbs={page.breadcrumbs} />
        <div className="contatti_template__header">
          <h1>{page.titolo}</h1>
          {!!page.descrizione && <div dangerouslySetInnerHTML={{ __html: page.descrizione }} />}
        </div>
        <FormContatti motivazioni={motivazioni} reparti={reparti} nazioni={nazioni} />
        <div className="contatti_template__team">
          <h2>
            <Trans chiave="Il nostro Team" />
          </h2>
          <div className="contatti_template__team__container">
            {reparti &&
              reparti?.map((reparto, i) => (
                <TeamCard
                  key={i}
                  id={i}
                  title={reparto?.nome}
                  description={reparto?.descrizione}
                  img={reparto?.immagine}
                  email={reparto?.email}
                  tel={reparto?.telefono}
                  setReparto={setRepartoId}
                  selectedId={repartoId}
                  mostraPersone={reparto?.persone_reparto?.length > 0}
                />
              ))}
          </div>
        </div>
        <div className="contatti_template__buttons">
          <div className="contatti_template__persone w-container">
            <div className="row">
              {reparti[repartoId]?.persone_reparto.map((item) => (
                <div className="col-3 item">
                  <p className="item__name">{item.nome}</p>
                  <p className="item__email">{item.email}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {contattaciMenuItem?.titolo && customerServiceMenuItem?.titolo && (
        <div className="contatti_template__customer">
          <div className="contatti_template__customer__leftSide">
            <h3>{customerServiceMenuItem?.titolo}</h3>
            <br />
            <div
              style={{ wordWrap: 'break-word' }}
              dangerouslySetInnerHTML={{
                __html: customerServiceMenuItem?.descrizione_html,
              }}
            />
          </div>
          <div className="contatti_template__customer__rightSide">
            <h3>{contattaciMenuItem?.titolo}</h3>
            <br />
            <div
              style={{ wordWrap: 'break-word' }}
              dangerouslySetInnerHTML={{
                __html: contattaciMenuItem?.descrizione_html,
              }}
            />
          </div>
        </div>
      )}
    </>
  )
}

export default ContattiTemplate
